import React from 'react';
import { useTranslation } from 'react-i18next';
import { HighlightSection } from './styles';

export const CreditImpactScript = () => {
    const { t } = useTranslation();
 
    return (
        <>
            <div><strong>{t('credit_score.script.probe1')}</strong></div>
            <div>
                <em>{t('credit_score.script.proof.title')}</em>{t('credit_score.script.proof.1')}
                <HighlightSection>{t('credit_score.script.note.title')}{t('credit_score.script.note.1')}</HighlightSection>
            </div>
            <div>
                <em>{t('credit_score.script.proof.title')}</em>{t('credit_score.script.proof.2')}
                <HighlightSection>{t('credit_score.script.note.title')}{t('credit_score.script.note.2')}</HighlightSection>
            </div>
            <div>
                <em>{t('credit_score.script.proof.title')}</em>{t('credit_score.script.proof.3')}
                <HighlightSection>{t('credit_score.script.note.title')}{t('credit_score.script.note.3')}</HighlightSection>
            </div>
            <div>{t('credit_score.script.probe2')}</div>
        </>
    );
};

export default CreditImpactScript;
